import React from 'react';
import KkpPlanningEmptyState from './KkpPlanningEmptyState';

/**
 * Aperçu fidèle au PDF généré côté API (même fichier que le téléchargement).
 */
const PlanDeComPdfPreview = ({
  url = null,
  loading = false,
  error = null,
  emptyMessage = 'Aucun aperçu PDF disponible',
  landscape = false,
}) => {
  if (loading && !url) {
    return <KkpPlanningEmptyState loading />;
  }

  if (error) {
    return <KkpPlanningEmptyState message={error} />;
  }

  if (!url) {
    return <KkpPlanningEmptyState message={emptyMessage} />;
  }

  return (
    <div className={`kkp-pdc-pdf-preview${landscape ? ' kkp-pdc-pdf-preview--landscape' : ''}`}>
      {loading ? (
        <div className="kkp-pdc-pdf-preview__busy text-secondary-light small mb-2">
          Mise à jour de l’aperçu…
        </div>
      ) : null}
      <iframe
        title="Aperçu PDF"
        src={url}
        className="kkp-pdc-pdf-preview__frame"
      />
    </div>
  );
};

export default PlanDeComPdfPreview;
